import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import SideMenu from "./SideMenu/SideMenu";
import { useContext } from "react";
import GlobalContext from "../../context/GlobalContext";

const Layout = (props) => {
    
    var globalContext = useContext(GlobalContext)
    return (
        <>
        {globalContext.token != null && globalContext.token !=='' ?
            <>
            <Header></Header>
            <SideMenu></SideMenu>
            </>
        :
        ''
        }
        {props.children}
        {globalContext.token != null && globalContext.token !=="" ?
            <Footer></Footer>
        :
        ''
        }
      </>
    );
  };
  
  export default Layout;